<template>
  <div>
    <span class="flex mb-8">
      <h3 class="font-medium text-m1 mb-8">Matches your job</h3>
      <img v-if="isBasic" src="../../images/applications/unlock-premium.svg" alt="Upgrade To Premium" class="ml-8 mb-8" />
    </span>
    <div v-if="isBasic">
      <li class="text-grey-body flex text-caption items-center mb-8">
        <img src="../../images/applications/basic-match.svg" alt="Upgrade To Premium" class="mr-8" />
        <span>See what skills this sitter has that match your job requirements</span>
      </li>
      <Button
        value="Upgrade To Premium"
        variant="outlined"
        class="w-full xl:w-auto mt-16"
        :href="upgradeUrl"
        @click="upgradeClicked"
      />
    </div>
    <div v-else>
      <ul class="mb-16">
        <li v-for="(match, index) in matchingRequirements" :key="index" class="flex text-grey-body items-center mb-8">
          <TickIcon aria-hidden="true" class="mr-8" color="#FF0064" />
          <span>{{ match }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import TickIcon from '@/graphics/icons/TickIcon.vue';
import Button from '@/components/button/Button.vue';
import { sendSegmentEvent } from '../../lib/segment';
import { setRecentlyViewedProviderId } from '@/lib/recentlyViewedProfile';

interface ApplicationDetails {
  matchingRequirements?: string[];
  sitter?: {
    id?: string;
  };
}

export default {
  components: {
    TickIcon,
    Button,
  },
  props: {
    applicationDetails: {
      type: Object as () => ApplicationDetails,
      required: false,
      default: () => ({}),
    },
    isBasic: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    matchingRequirements(): string[] {
      return (this as any).applicationDetails?.matchingRequirements || [];
    },
    upgradeUrl(): string {
      return '/upgrade/pricing';
    },
  },
  methods: {
    upgradeClicked(): void {
      setRecentlyViewedProviderId((this as any).applicationDetails?.sitter?.id);
      sendSegmentEvent('Applicant_MatchesJob_UpgradePricing', {});
    },
  },
};
</script>
